





































































import { defineComponent, computed, ref } from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import { useSlickOptions } from "~/stores/extensionApi";
import { checkHttpLink, changeImage } from "~/helpers";

import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination]);

export default defineComponent({
  name: "ProductsOnOff",
  components: {
    SkeletonPlaceholder,
    LazyComponent,
    Swiper,
    SwiperSlide,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const slickOptions = useSlickOptions();

    const isOnline = ref(1);

    const slickOption = {
      slidesPerView: 2.3,
      slidesPerGroup: 2,
      spaceBetween: 8,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 32,
        },
      },
    };

    const getTitle = computed(() => {
      return props.item?.title;
    });

    const filteredBanners = computed(() => {
      return props.item.promotion_onoff
        ? props.item.promotion_onoff.filter((e) => e.title_id == isOnline.value)
        : [];
    });

    return {
      slickOption,
      getTitle,
      isOnline,
      checkHttpLink,
      changeImage,
      filteredBanners,
    };
  },
});
